import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface LocationCardFieldsProps {
  children: React.ReactNode;
}

const FieldsGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  // Mobile: 2 columns
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: "4px 0",
  // MD+: up to 4 columns
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  },
}));

/**
 * Responsive grid container for `LocationCard.Field` children.
 * 2 columns on mobile, 4 on MD+. Accepts only `LocationCard.Field` children
 * but is not enforced at type level — any React node is valid.
 */
const LocationCardFields = ({ children }: LocationCardFieldsProps) => (
  <FieldsGrid>{children}</FieldsGrid>
);

export default LocationCardFields;

